import { useEffect } from "react";
import { erpUrl } from "@lib/erpUrl";

interface ErpRedirectProps {
  /** The ERP path, e.g. `/erp/carlao/analytics`. */
  path: string;
}

/**
 * Spec 20261015-160924 T12: an old address of a page that moved to the ERP. It replaces the history entry, so the
 * back button does not bounce the person between the two portals.
 */
export function ErpRedirect({ path }: ErpRedirectProps) {
  const url = erpUrl(import.meta.env.VITE_APP_SCHEDULE_URL, path);

  useEffect(() => {
    if (url) window.location.replace(url);
  }, [url]);

  if (!url) return <p role="alert">URL do serviço não configurada. Contate o administrador.</p>;
  return <p role="status">Abrindo o ERP…</p>;
}

export default ErpRedirect;
